import { Component, Input, OnInit } from '@angular/core';
import { DictionaryContractType } from 'src/app/extensions/constants/dictionaryConstants/dictionaryConstants';

@Component({
  selector: 'contract-detail-insurances',
  templateUrl: './contract-detail-insurances.component.html',
  styleUrls: ['./contract-detail-insurances.component.scss'],
  standalone: false,
})
export class ContractDetailInsurancesComponent implements OnInit {
  @Input() insurances: app.models.ContractDetailInsuranceModel[];
  @Input() props: app.models.DynamicPropsDictionary;
  @Input() contractType: string;

  public ContractType = DictionaryContractType;

  public insurance: app.models.ContractDetailInsuranceModel;

  public constructor() {}

  ngOnInit(): void {
    this.insurances;
  }

  public viewInsuranceHandler(insuranceId: string) {
    this.insurance = this.insurances.find(x => x.insuranceId == insuranceId);
  }

  public returnHandler() {
    this.insurance = null;
  }
}
